export default __webpack_public_path__ + "static/media/filters.1a2412f1.svg";